import React, { Component } from "react";
import { View, Platform } from "react-native";
import Text from "./TextFont";
// ===
import ArTheme from "../argon-ui/Theme";
// === Components ===
import Switch from "../components/ToggleSwitch";
import { IconButton } from "../components_v2/Buttons";
import Theme from "../argon-ui/Theme";

import * as faCharCodes from "../../assets/consts/faCharCodes";
import PropTypes from "prop-types";
import Spinner from "./Spinner";
import { getDir } from "../util";

class AreaArmItem extends Component {
  static propTypes = {
    value: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    armInProgress: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    message: PropTypes.string,
    status: PropTypes.oneOf([true, false, undefined]),
    style: PropTypes.shape(),
  };

  render() {
    let {
      value,
      label,
      armInProgress,
      errorMessage,
      message,
      status,
      style,
      onActiveToggleStyle = null,
    } = this.props;
    let BOTTOM_PADDING = 10;
    return (
      <View>
        <View
          style={{
            flexDirection: "row",
            paddingVertical: 10,
            paddingHorizontal: 5,
            paddingBottom: message || errorMessage ? 0 : BOTTOM_PADDING,
            alignItems: "center",
            direction: getDir(),
          }}
        >
          {value && armInProgress == true && status == undefined ? (
            <View
              style={{
                width: 20,
                height: 20,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner />
            </View>
          ) : armInProgress == true && status == true ? (
            <IconButton
              icon={{
                code: faCharCodes.faCheck, //"\uf00c",
                style: {
                  fontFamily: "FontAwesomeProRegular",
                  fontSize: 16,
                  color: "green",
                },
              }}
            />
          ) : (
            <Switch
              isOn={value}
              size="small"
              onColor={
                onActiveToggleStyle ? onActiveToggleStyle : Theme.COLORS.ACTIVE
              }
              offColor={Theme.COLORS.MUTED}
              onToggle={() => this.props.onChange && this.props.onChange()}
            />
          )}
          <Text style={{ marginHorizontal: 5, fontSize: 12 }}>{label} </Text>
          {/* {value && armInProgress == true && status == undefined && (
            <IconButton
              icon={{
                code: faCharCodes.faHourglassStart, //"\uf251",
                style: {
                  fontFamily: "FontAwesomeProRegular",
                  fontSize: 25,
                  color: "grey",
                },
              }}
            />
          )} */}
          {status == false && (
            <IconButton
              icon={{
                code: faCharCodes.faTimes, //"\uf00d",
                style: {
                  fontFamily: "FontAwesomeProRegular",
                  fontSize: 20,
                  color: "red",
                },
              }}
            />
          )}
        </View>

        {/* errorMessage  */}
        {errorMessage != undefined && (
          <View style={{ paddingBottom: BOTTOM_PADDING }}>
            <Text
              style={{
                color: "#F00",
                fontSize: 11,
                marginStart: 50,
                textAlign: Platform.OS == "ios" ? "left" : "auto",
              }}
            >
              {errorMessage}
            </Text>
          </View>
        )}

        {/* Message  */}
        {message != undefined && (
          <View style={{ paddingBottom: BOTTOM_PADDING }}>
            <Text
              style={{
                color: ArTheme.COLORS.MUTED,
                fontSize: 11,
                marginStart: 50,
              }}
            >
              {message}
            </Text>
          </View>
        )}
      </View>
    );
  }
}

export default AreaArmItem;

// const styles = StyleSheet.create({})
